<template>
  <div class="app-forgot-password-channel">
    <dyn-slot :slot-data="slotData">
      <slot name="msisdn">
        Ihr Passwort wird automatisch zurückgesetzt. Sie erhalten einen SMS-Code
        an oder einen Link an Ihre hinterlegte E-Mail.
      </slot>
    </dyn-slot>
    <b-form>
      <b-form-group
        label="Passwort-zurücksetzen"
        label-class="visually-hidden"
      >
        <b-form-radio-group  v-model="channelLocal" stacked
                            :state="isValid('channelLocal')">
          <b-form-radio name="channelLocal" value="email">E-Mail anfordern</b-form-radio>
          <b-form-radio name="channelLocal" value="sms">SMS anfordern</b-form-radio>
        </b-form-radio-group>
      </b-form-group>
        <Stepper
          :disabled-next="$v.$invalid || loading"
          :loading-next="loading"
          @prev="back()"
          @next="save()"
        >
          <template #btnPrev><slot name="btnBack">zurück</slot></template>
          <template #btnNext><slot name="btnNext">weiter</slot></template>
        </Stepper>
    </b-form>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { BForm, BFormRadioGroup, BFormRadio } from 'bootstrap-vue'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import preFilledInput from '../../../../../mixins/preFilledInput'
import isValid from '../../../../../mixins/isValid'
import Stepper from '@/components/generic/Stepper.vue'

export default {
  name: 'ForgotPasswordChannel',
  mixins: [
    preFilledInput('channelLocal', 'channel'),
    validationMixin,
    isValid
  ],
  data () {
    return {
      loading: false
    }
  },
  computed: {
    slotData () {
      return {
        msisdn: this.msisdn,
        loading: this.loading
      }
    },
    ...mapGetters('forgotPassword', [
      'msisdn',
      'channel'
    ])
  },
  components: { BForm, BFormRadioGroup, BFormRadio, Stepper },
  methods: {
    ...mapMutations('forgotPassword', [
      'recaptureMsisdn'
    ]),
    ...mapActions('forgotPassword', [
      'performResetChannel'
    ]),
    save () {
      this.loading = true
      this.performResetChannel(this.channelLocal)
        .then(() => {
          this.loading = false
        }, (e) => {
          this.loading = false
        })
    },
    back () {
      this.recaptureMsisdn(this.channelLocal)
    }
  },
  validations: {
    channelLocal: {
      required
    }
  }
}
</script>
